import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { BUSINESS_INFO, NAV_LINKS } from "../config";

export function Footer() {
  return (
    <footer className="relative mt-auto bg-[#FEFAF3] text-black">
      {/* Main Footer */}
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* Col 1: Brand & Philosophy */}
          <div className="space-y-4">
            <Logo size="lg" />
            <div className="pt-2">
              <a
                href={BUSINESS_INFO.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-xs font-semibold text-black transition-colors hover:underline"
              >
                <i className="fa-brands fa-facebook text-base text-black" aria-hidden="true" />
                <span>Følg os på Facebook</span>
              </a>
            </div>
          </div>

          {/* Col 2: Navigation links */}
          <div>
            <h4 className="font-heading text-xs font-semibold uppercase tracking-wider text-black">
              Hurtige links
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-black">
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="inline-flex items-center gap-2 transition-colors hover:underline text-black"
                  >
                    <i className="fa-solid fa-angle-right text-[10px] text-black" aria-hidden="true" />
                    <span>{link.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Services overview */}
          <div>
            <h4 className="font-heading text-xs font-semibold uppercase tracking-wider text-black">
              Ydelser
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-black">
              <li>
                <Link to="/ydelser-priser" className="transition-colors hover:underline text-black">
                  Klip, vask, føn samt negle
                </Link>
              </li>
              <li>
                <Link to="/ydelser-priser" className="transition-colors hover:underline text-black">
                  Vask & føn
                </Link>
              </li>
              <li>
                <Link to="/ydelser-priser" className="transition-colors hover:underline text-black">
                  Klip af poter og negle
                </Link>
              </li>
              <li>
                <Link to="/hvalpepakke" className="transition-colors hover:underline text-black">
                  Hvalpepakke (3 rolige besøg)
                </Link>
              </li>
              <li>
                <Link to="/ydelser-priser" className="transition-colors hover:underline text-black">
                  Åbningstilbud
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Contact info */}
          <div>
            <h4 className="font-heading text-xs font-semibold uppercase tracking-wider text-black">
              Salonen i Fredericia
            </h4>
            <div className="mt-4 space-y-3 text-sm text-black">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot mt-1 text-black" aria-hidden="true" />
                <div>
                  <p className="font-medium text-black">{BUSINESS_INFO.name}</p>
                  <p>{BUSINESS_INFO.street}</p>
                  <p>{BUSINESS_INFO.city}</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <i className="fa-solid fa-phone text-black mt-1" aria-hidden="true" />
                <div>
                  <a
                    href={`tel:${BUSINESS_INFO.phoneRaw}`}
                    className="font-semibold text-black transition-colors hover:underline whitespace-nowrap block"
                  >
                    {BUSINESS_INFO.phone}
                  </a>
                  <p className="text-xs text-neutral-600 mt-0.5">
                    Telefontid kl. 8.00–8.30 (send gerne SMS)
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-black" aria-hidden="true" />
                <a
                  href={`mailto:${BUSINESS_INFO.email}`}
                  className="transition-colors hover:underline text-black whitespace-nowrap"
                >
                  {BUSINESS_INFO.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar with CVR integrated directly in copyright */}
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-[#E8DFD5] pt-8 text-xs text-black sm:flex-row">
          <p>© {new Date().getFullYear()} {BUSINESS_INFO.name} · CVR: {BUSINESS_INFO.cvr} · Alle rettigheder forbeholdes.</p>
        </div>
      </div>
    </footer>
  );
}
